module.exports = __webpack_public_path__ + "img/doc.43edec8b.png";